import * as Types from '../../../../graphql/__generated__/globalTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type LoginAsShopFromEmployeeQueryVariables = Types.Exact<{
  input: Types.LoginAsShopInput;
}>;


export type LoginAsShopFromEmployeeQuery = { __typename?: 'Query', loginAsShop: { __typename?: 'AuthResponse', token: string, authTokenType: Types.AuthTokenType, user: { __typename?: 'AuthResponseUser', id: string, companyName?: string | null, authUserType: Types.AccountType }, shopLocation?: { __typename?: 'AuthResponseLocation', id: string, name: string } | null } };


export const LoginAsShopFromEmployeeDocument = gql`
    query LoginAsShopFromEmployee($input: LoginAsShopInput!) {
  loginAsShop(input: $input) {
    user {
      id
      companyName
      authUserType
    }
    token
    authTokenType
    shopLocation {
      id
      name
    }
  }
}
    `;

/**
 * __useLoginAsShopFromEmployeeQuery__
 *
 * To run a query within a React component, call `useLoginAsShopFromEmployeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoginAsShopFromEmployeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoginAsShopFromEmployeeQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginAsShopFromEmployeeQuery(baseOptions: Apollo.QueryHookOptions<LoginAsShopFromEmployeeQuery, LoginAsShopFromEmployeeQueryVariables> & ({ variables: LoginAsShopFromEmployeeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoginAsShopFromEmployeeQuery, LoginAsShopFromEmployeeQueryVariables>(LoginAsShopFromEmployeeDocument, options);
      }
export function useLoginAsShopFromEmployeeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoginAsShopFromEmployeeQuery, LoginAsShopFromEmployeeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoginAsShopFromEmployeeQuery, LoginAsShopFromEmployeeQueryVariables>(LoginAsShopFromEmployeeDocument, options);
        }
export function useLoginAsShopFromEmployeeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LoginAsShopFromEmployeeQuery, LoginAsShopFromEmployeeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LoginAsShopFromEmployeeQuery, LoginAsShopFromEmployeeQueryVariables>(LoginAsShopFromEmployeeDocument, options);
        }
export type LoginAsShopFromEmployeeQueryHookResult = ReturnType<typeof useLoginAsShopFromEmployeeQuery>;
export type LoginAsShopFromEmployeeLazyQueryHookResult = ReturnType<typeof useLoginAsShopFromEmployeeLazyQuery>;
export type LoginAsShopFromEmployeeSuspenseQueryHookResult = ReturnType<typeof useLoginAsShopFromEmployeeSuspenseQuery>;
export type LoginAsShopFromEmployeeQueryResult = Apollo.QueryResult<LoginAsShopFromEmployeeQuery, LoginAsShopFromEmployeeQueryVariables>;